import React from 'react';
import { Music, Zap, Mail, Lock, Shield, Globe, FileText } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-gray-900 py-10 md:py-12 px-4" data-id="element-109">
      <div className="max-w-4xl mx-auto" data-id="element-110">
        {/* Final CTA */}
        <div className="text-center mb-8 md:mb-10" data-id="element-111">
          <p className="font-nunito font-black text-white text-xl md:text-3xl mb-2 flex items-center justify-center gap-2" data-id="element-112">
            <Music className="w-7 h-7 text-orange-400" data-id="element-113" />
            ¡Clase de música resuelta por 1 año entero!
          </p>
          <a href="https://hotmart.com" target="_blank" rel="noopener noreferrer" className="btn-pulse inline-flex items-center justify-center gap-2 w-full sm:w-auto bg-gradient-to-r from-orange-500 to-red-500 text-white font-nunito font-black text-base md:text-lg px-6 md:px-8 py-4 rounded-2xl shadow-lg mt-4 cursor-pointer" aria-label="Acceso inmediato por $17 USD" data-id="element-114">
            <Zap className="w-5 h-5" data-id="element-115" />
            ACCESO INMEDIATO — $17 USD
          </a>
        </div>

        {/* Divider */}
        <div className="h-px bg-gray-700 mb-6 md:mb-8" data-id="element-116" />

        {/* Legal info */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 text-center md:text-left mb-6 md:mb-8" data-id="element-117">
          <div data-id="element-118">
            <h4 className="font-nunito font-bold text-white mb-3 flex items-center justify-center md:justify-start gap-2" data-id="element-119">
              <Mail className="w-4 h-4 text-orange-400" data-id="element-120" /> Contacto
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-121">soporte@planesmusica.com</p>
          </div>
          <div data-id="element-122">
            <h4 className="font-nunito font-bold text-white mb-3 flex items-center justify-center md:justify-start gap-2" data-id="element-123">
              <Lock className="w-4 h-4 text-orange-400" data-id="element-124" /> Seguridad
            </h4>
            <p className="text-gray-400 text-sm flex items-center justify-center md:justify-start gap-1" data-id="element-125">
              <Shield className="w-3.5 h-3.5 text-green-400" data-id="element-126" /> 100% seguro:
              Pago via Hotmart/Stripe
            </p>
            <p className="text-gray-400 text-sm mt-1" data-id="element-127">
              Garantía: 30 días completo reembolso
            </p>
          </div>
          <div data-id="element-128">
            <h4 className="font-nunito font-bold text-white mb-3 flex items-center justify-center md:justify-start gap-2" data-id="element-129">
              <Globe className="w-4 h-4 text-orange-400" data-id="element-130" /> Disponibilidad
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-131">
              México, España, América Latina, USA
            </p>
            <p className="text-gray-400 text-sm mt-1" data-id="element-132">
              <a href="#" className="text-orange-400 hover:text-orange-300 transition-colors flex items-center justify-center md:justify-start gap-1 mt-1" data-id="element-133">
                <FileText className="w-3.5 h-3.5" data-id="element-134" /> Política de privacidad
              </a>
            </p>
          </div>
        </div>

        {/* Bottom */}
        <div className="text-center text-gray-500 text-xs md:text-sm" data-id="element-135">
          <p data-id="element-136">© 2026 36 Semanas de Música. Todos los derechos reservados.</p>
          <p className="mt-1" data-id="element-137">Diseñado con amor para maestros de México</p>
        </div>
      </div>
    </footer>;
}